import * as S from "../../Style/Page/Social.style.js";
import { Link } from "react-router-dom";
import { ReactComponent as Home } from "../../assets/icon/home.svg";
import Arrow from "../../assets/icon/lnb_arrow.png";
import PageTitle from "../../Component/PageTitleSocial.js";
import HatPageTopLine from "../../Component/SocialPageTopLine.js";
// const MainImg = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/01. 영안복지사업.77e8ba671a5de01de40d.png`;
import MainImg from "../../assets/SocialService/MainImg.png";
import TableImgKor from "../../assets/GeneralBusiness/백학마을.png";
import TableImgEng from "../../assets/GeneralBusiness/백학마을영어.png";

const Item1 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/02. 독립기념관 기증.1a14dee992f99789cc93.png`;
const Item2 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/03. 안중근의사 기념관.d1b3a2f9971384d11a01.png`;
const Item3 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/04. 한국전 참전 기념 사업 지원.a47160fc55608e534592.png`;
const Item4 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/05. 미국시티오브호프 LA 시립병원.02a93ae77767d21b55a9.png`;
const Item5 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/06. 이화여자대학교 교회 설립.e2bc4dcda293f35cf53b.png`;
const Item6 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/07. 길상사 석탑 기증.eeca14b545117096f83b.png`;
const SocialService = () => {
  return (
    <S.Page className={localStorage.getItem("language")}>
      <HatPageTopLine name={"사회사업"} />
      <section className="section" id="hat-introduce-section">
        <S.PageNavidation>
          <Link to="/" className="logo">
            <Home />
          </Link>
          <S.Nav height={"364px"}>
            <S.NavItem>
              <Link to="/SocialBusiness/SocialService">
                <div className="kor">사회사업</div>
                <div className="eng">Social Business</div>
              </Link>
            </S.NavItem>

            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">지게차사업</div>
                  <div className="eng">Fork Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/introduce">
                  <div className="kor">자동차사업</div>
                  <div className="eng">Car Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">버스사업</div>
                  <div className="eng">Bus Business</div>
                </Link>
              </S.NavItem>

              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/introduce">
                  <div className="kor">일반사업</div>
                  <div className="eng">General Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">사회사업</div>
                  <div className="eng">Social Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/WBH/WBH">WBH</Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"260px"}>
            <S.NavItem>
              <Link to="/SocialBusiness/SocialService">
                <div className="kor">복지사업</div>
                <div className="eng">Welfare Services</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">복지사업</div>
                  <div className="eng">Welfare Services</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/EducationBusiness">
                  <div className="kor">교육사업</div>
                  <div className="eng">YoungAn Education Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/Scholarship">
                  <div className="kor">연암장학회</div>
                  <div className="eng">Yeonam Scholarship Foundation</div>
                </Link>
              </S.NavItem>
              
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/Obs">OBS</Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/Museum">
                  <div className="kor">영안역사관</div>
                  <div className="eng">YoungAn History Museum</div>
                </Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
        </S.PageNavidation>
        <div className="wrap">
          <div className="inner">
            <PageTitle titleko={"영안 복지사업 소개"} titleeng={"Introduction of YoungAn Welfare Services"} />
            <img src={MainImg} alt="" className="fullsize-map" />
            <div className="page-text">
              <div className="page-text-title">
                <div className="kor"><h2>1995년 ~ 백성학 명예회장 복지사업 기록</h2></div>
                <div className="eng"><h2>1995 ~ Records of social welfare services by Honorary Chairman Baik Sung-Hak</h2></div>
              </div>
              <div className="kor">
                1) 1955년~1959년 (공원, 점원 시절) : 4년간 공원, 점원 생활을 하며
                받은 급여의 ¼을 어려운 사람을 도움 <br />
                2) 1959년~1970년 (개업 직후부터 복지사업 진행) : 성탄절마다 돈과
                쌀, 생필품을 담은 50~100개의 선물꾸러미를 만들어 점원들과 함께
                남산 판자촌 및 청계천 아래 걸인들에게 나누어줌 <br />
                3) 1970~1977년 (국내외 복지 지원 본격 시작)
                <br /> 4) 1978년~ : 백성학 명예회장은 해외로 진출하고 사업을
                확장한 후에도 어려운 이들을 위한 봉사를 멈추지 않고, 지속하고 있음
              </div>
              <div className="eng">
                1) 1955 ~ 1959 (As a production worker / store clerk) : During his four years as a production worker
                and store clerk, Mr.Baik spent half of his salary to help those in need.
                <br />
                2) 1959 ~ 1970 (He started welfare services right after opening his business) :
                He and his store clerks provided 50 to 100 gift parcels that contained money, rice, and daily necessities,
                to the poor neighborhood on every year Christmas day.
                <br />
                3) 1970 ~ 1977 (Full launch of social welfare programs both in Korea and overseas)
                <br />
                4) 1978 ~ : Honorary Chairman Baik Sung-hak continues his volunteer work for those in need,
                even after expanding his business overseas.
              </div>
            </div>

            <PageTitle
              titleko={"한국 백학재단 소개"}
              titleeng={"Introduction of Baik's Foundation"}
              link={"http://www.baiksfoundation.or.kr/"}
            />
            <div className="page-text">
              <div className="kor">
                1) 설립일 : 2008년 12월 31일
                <br />
                2) 영안은 2008년 말, 국내,외에서 보다 체계적인 복지사업을 진행하기 위해 외교부 소관법인인 백학재단을 설립하여 나눔을 지속해 오고 있음.
                <br />
              </div>
              <div className="eng">
                1) Date of establishment : December 31, 2008
                <br />
                2) At the end of 2008, Young An Hat Company established the Baik's Foundation that is under the auspices 
     of the Ministry of Foreign Affairs and Trade in order to practice a more systematic philanthropy works.
              </div>





              {/* <div className="page-text-title mt-4 mb-2">
                <div className="kor">장학재단 소개 : 연암장학회</div>
                <div className="eng">Introduction of Scholarship Foundation : Yeonam Foundation</div>
              </div> */}
              {/* <div className="kor">
                1) 국내외 불우한 학생 장학금 지급중
                <div className="page-text-title mt-4 mb-2">백학마을 현황</div>
                1) 한국백학마을 (1986)
                <br />
                2) 중국백학마을 (1993)
                <br />
                3) 스리랑카백학마을 (1993)
                <br />
                4) 코스타리카백학마을 (1994)
                <br />
                5) 베트남백학마을 (2004)
                <br />
                6) 에티오피아백학마을 (2010)
                <br />
                7) 온두라스백학마을 (2018)
              </div>
              <div className="eng">
                1) Financial aid scholarships for national and international students
                <br />
                <div className="page-text-title mt-4 mb-2">Status of Baekhak Village</div>
                1) Korean Baekhak Village (1986)
                <br />
                2) China Baekhak Village (1993)
                <br />
                3) Sri Lanka Baekhak Village (1993)
                <br />
                4) Costa Rica Baekhak Village (1994)
                <br />
                5) Vietnam Baekhak Village (2004)
                <br />
                6) Ethiopia Baekhak Village (2010)
                <br />
                7) Honduras Baekhak Village (2018)
              </div> */}
            </div>


            <PageTitle
              titleko={"CR 백학재단 소개"}
              titleeng={"Introduction of Baik’s Foundation (Costa Rica)"}
            />
            <div className="page-text">
              <div className="kor">
                1) 설립일 : 2008년 12월 31일
                <br />
                2) 코스타리카에 설립되어 해당 국가와 중남미 지역의 어려운 이들을 위한 봉사를 진행하고 있음.
                <br />
              </div>
              <div className="eng">
                1) Date of establishment : December 31, 2008
                <br />
                2)  Baik's Foundation was also established in Costa Rica with a purpose of philanthropy work for the underprivileged people in the Central American countries and continues supporting them.
              </div>
            </div>

            {/* <S.ImgHolderFlex>
              <S.ImgHolderHarf>
                <img src={Item1} className="holder-img" alt="" />
                <div className="holder-name">
                  <div className="kor">
                    독립기념관 기능(1994)
                    <br />
                    <span>독립기념관 화재를 계기로 세상에 알려짐</span>
                  </div>
                  <div className="eng">
                    Donation to the Independence Hall of Korea (1994)
                    <span>This fact was found out through news coverage of the fire at the Hall.</span>
                  </div>
                </div>
              </S.ImgHolderHarf>

              <S.ImgHolderHarf>
                <img src={Item2} className="holder-img" alt="" />
                <div className="holder-name">
                  <div className="kor">
                    안중근의사 기념관(1994)
                    <br />
                    <span>
                      1994년부터 2013까지 안중근 의사 숭모회에 약 5억원 지원
                    </span>
                  </div>
                  <div className="eng">
                    Ahn Junggeun Memorial Museum(1994)
                    <span>From 1994 to 2013, approximately 500 million won was supported to the Ahn Junggeun Memorial Association.</span>
                  </div>
                </div>
              </S.ImgHolderHarf>
            </S.ImgHolderFlex> */}
            {/* <S.ImgHolderFlex>
              <S.ImgHolderHarf>
                <img src={Item3} className="holder-img" alt="" />
                <div className="holder-name">
                  <div className="kor">
                    한국전 참전 기념 사업 지원(1995)
                    <br />
                    <span>백회장과 빌리가 함께 공식행사에 초청받음</span>
                  </div>
                  <div className="eng">
                    Support for the commemoration of the Korean War (1995)
                    <span>Mr.baik and Billy were invited as guests of honor</span>
                  </div>
                </div>
              </S.ImgHolderHarf>

              <S.ImgHolderHarf>
                <img src={Item4} className="holder-img" alt="" />
                <div className="holder-name">
                  <div className="kor">
                    미국시티오브호프 LA 시립병원(1994)
                    <br />
                    <span>죽어가는 환자들을 살리기 위한 시립병원을 지원</span>
                  </div>
                  <div className="eng">
                    'City of Hope' Municipal Hospital, Los Angeles (1994)
                    <span>Support for establishment of a Municipal Hospital for patients in danger.</span>
                  </div>
                </div>
              </S.ImgHolderHarf>
            </S.ImgHolderFlex> */}
            {/* <S.ImgHolderFlex>
              <S.ImgHolderHarf>
                <img src={Item5} className="holder-img" alt="" />
                <div className="holder-name">
                  <div className="kor">
                    이화여자대학교 교회 설립(2000)
                    <br />
                    <span>
                      북한에서 기도하며 돌아가신 어머니 김숙녀 여사를 기념
                    </span>
                  </div>
                  <div className="eng">
                    Donation of founding Ewha Womans University Church (2000)
                    <span>in memory of his mother Kim Suk-nyeo, who passed away in prayer in North Korea.</span>
                  </div>
                </div>
              </S.ImgHolderHarf>

              <S.ImgHolderHarf>
                <img src={Item6} className="holder-img" alt="" />
                <div className="holder-name">
                  <div className="kor">
                    길상사 석탑 기증(2012)
                    <br />
                    <span>성북동에 세워진 절이 잘 되길 바라며 특별 기증</span>
                  </div>
                  <div className="eng">
                    Donation of a stone pagoda to Gilsangsa Temple in Seongbuk-dong, Seoul (2012)
                    <span>Donated with wishes for prosperity to the temple in Seongbuk-dong.</span>
                  </div>
                </div>
              </S.ImgHolderHarf>
            </S.ImgHolderFlex> */}


            <PageTitle
              titleko={"백학마을 소개"}
              titleeng={"Introduction to Baik’s Village"}
            />
            <div className="page-text">
              <div className="kor">
                <img src={TableImgKor} alt="" className="fullsize-map kor" />
              </div>
              <div className="eng">
                
                <img src={TableImgEng} alt="" className="fullsize-map eng" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </S.Page>
  );
};

export default SocialService;
